function n(...n){return n.reduce(((n,t)=>null==t?n:function(...p){n.apply(this,p),t.apply(this,p)}),(()=>{}))}export{n as c};
